import actions from './actions'
import mutations from './mutations'

const dashboard = {
    namespaced: true,
    state: {
        balanceHistory: [],
        referralsHistory: [],
        balanceHistoryTable: [],
        referralsHistoryTable: [],
        ordersHistory: [],
        ordersHistoryTable: [],
        isLoaded: false
    },
    mutations,
    actions
}

export default dashboard
